import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'data-fetching-client';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import businessUnitsQuery from 'MeetingsLib/query/businessUnitsQuery';
// @ts-expect-error untyped import
import { getHasBusinessUnitsAccess } from 'MeetingsAdmin/selectors/AccessSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitSelect = ({
  businessUnitId,
  onChange,
  disabled
}) => {
  const hasBusinessUnitsAccess = useSelector(getHasBusinessUnitsAccess);
  const {
    data: businessUnitsData,
    loading,
    error
  } = useQuery(businessUnitsQuery, {
    skip: !hasBusinessUnitsAccess
  });
  const businessUnitOptions = useMemo(() => businessUnitsData && [{
    text: I18n.text('filters.businessUnit.all'),
    value: null
  }, ...businessUnitsData.businessUnits.map(businessUnit => Object.assign({}, businessUnit, {
    text: businessUnit.name,
    value: businessUnit.id
  }))], [businessUnitsData]);
  if (!hasBusinessUnitsAccess || loading || error) {
    return null;
  }
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.businessUnit.businessUnitLabel"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      "data-selenium-test": "businesss-unit-select",
      disabled: disabled,
      buttonUse: "link",
      value: businessUnitId,
      onChange: e => onChange(Number(e.target.value))
      // @ts-expect-error No overload matches this call.
      ,
      options: businessUnitOptions,
      placeholder: I18n.text('filters.businessUnit.all'),
      menuWidth: "auto"
    })
  });
};
export default BusinessUnitSelect;